import api from "@/api/users";
import store from "@/store/index";
//  USER ACTION
//  REMOVE FROM STORE/STORAGE
const removeUserInfo = ({ commit }) =>
  new Promise(resolve => {
    commit("REMOVE_USER_INFO");
    resolve();
  });

//  AUTH USER
const userLogin = ({ commit }, payload) =>
  new Promise((resolve, reject) => {
    api
      .userLogin(payload)
      .then(response => {
        if (response.status === "OK") {
          commit("UPDATE_USER_INFO", response.data);
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  CREATE USER
const createUser = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createUser(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  READ USER
const readCurrentUser = ({ commit }) =>
  new Promise((resolve, reject) => {
    const id = store.getters["user/getActiveUser"].id;
    api
      .readUser({ id })
      .then(response => {
        commit("UPDATE_USER_INFO", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readUser = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readUser(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readUsers = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readUsers(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  UPDATE USER
const updateUser = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updateUser(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  DELETE USER
const deleteUser = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteUser(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
export default {
  removeUserInfo,
  userLogin,
  createUser,
  readCurrentUser,
  readUser,
  readUsers,
  updateUser,
  deleteUser
};
